'use strict';

angular.module('youth').controller('LibraryCtrl', ['$state', 'savedActivities', 'activityResponseSvc', '$log', function ($state, savedActivities, activityResponseSvc, $log) {
  var vm = this;
  vm.tab = 'saved';
  vm.savedActivities = savedActivities;
  activityResponseSvc.getResponses().then(function (resp) {
    $log.debug('Previous responses: ', resp);
    vm.activityResponses = resp;
  });
  vm.select = function (activity, response) {
    $state.go('activityResponse', {
      response: response
    });
  };
}]);